import type { ProfileState } from './api';

export const profileReviewLabels = {
  draft: 'Draft',
  submitted: 'Submitted',
  approved: 'Approved',
  changes_requested: 'Changes requested',
};

export function profileReviewStage(profile: ProfileState | null) {
  if (profile?.reviewStage) return profile.reviewStage;
  if (profile?.approvalStatus === 'approved') return 'approved';
  if (profile?.approvalStatus === 'rejected') return 'changes_requested';
  return profile?.slug ? 'submitted' : 'draft';
}
